import { render, staticRenderFns } from "./FiltersCategories.vue?vue&type=template&id=d34b31b4&"
import script from "./FiltersCategories.vue?vue&type=script&lang=js&"
export * from "./FiltersCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports